import * as ex from "excalibur";
import { Resources } from "../../Resources";
import { Player } from "../../player";

import { goToScene } from "../../main";

import { playerState } from "../../state/stateManager";
import Marvin from "../../actors/characters/marvin";

export default class MarvinsHouse extends ex.Scene {
  constructor() {
    super();
    const player = new Player(20 * 16, 18 * 16);
    this.player = player;
    this.player.lastDir = "up";
    this.player.wearingVeil = false;
    this.player.z = 5;
  }
  onInitialize(engine) {
    Resources.MarvinsHouse.addToScene(this);
    console.log("marvinshouse: adding player: ", this.player);
    this.player.lastDir = "up";

    this.add(this.player);

    this.camera.zoom = 1;

    this.door = new ex.Trigger({
      pos: new ex.Vector(19 * 16, 19 * 16 + 8),
      width: 48,
      height: 16,
      filter: (actor) => {
        return actor.name === "player";
      },
      action: () => {
        goToScene("town", { x: 5 * 16, y: 48 * 16, direction: "down" });
      },
    });
    this.add(this.door);

    this.player.on("collisionstart", (e) => {
      if (e.other.owner.name === "marvin") {
        this.marvin.startInteraction(this.player.lastDir, this.player);
      }
    });
  }
  onActivate(data) {
    if (data.data) {
      console.log("have location data: ", data.data);
      this.player.pos = new ex.Vector(data.data.x, data.data.y);
    }
    let content = playerState.getContent();
    console.log("adding marvin");
    if (content.npcLocations.marvin.location == 0) {
      if (this.marvin == null || this.marvin == undefined) {
        this.marvin = new Marvin({ x: 14 * 16, y: 6 * 16 }, "marvinsHouse");
        this.marvin.z = 4;
        this.add(this.marvin);
      }
    }
  }
  onPostUpdate() {}
}
